<div class="main-screen-container">
    <div class="top-row">
        <button mat-flat-button class="btn-action btn-with-icon" color="accent"
            (click)="router.navigate(['users-list'])"><img style="width:25px;" src="/assets/img/back.png"
                alt="">Powrót</button>

    </div>
    <div class="list-container">
        <div class="d-flex flex-column">
            <h3>Edytuj Użytkownika</h3>
            <form [formGroup]="editForm" (ngSubmit)="onSubmit()" class="form-layout">
                <div class="d-flex flex-row mb-3 justify-content-around">

                    <div class="p-2 w-30" style="width:30%;">

                        <mat-form-field appearance="outline" class='w-100'>
                            <mat-label>Imię</mat-label>
                            <input matInput type="text" placeholder="Imię" required formControlName="name">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class='w-100'>
                            <mat-label>Nazwisko</mat-label>
                            <input matInput type="text" placeholder="Nazwisko" required formControlName="surname">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Numer telefonu</mat-label>
                            <input matInput placeholder="Numer telefonu" formControlName="phone">
                        </mat-form-field>
                        <mat-form-field *ngIf="0" appearance="outline" style="width:100%;">
                            <mat-label>Adres email</mat-label>
                            <input matInput type="email" placeholder="email" required formControlName="email">
                        </mat-form-field>
                    </div>
                    <div class="p-2 w-30" style="width:30%;">
                        <mat-form-field appearance="outline" style="width:100%;">
                            <mat-label>Organizacja</mat-label>
                            <mat-select formControlName="organization_id">
                                @for (item of organizations; track item) {
                                <mat-option [value]="item.id">{{item.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>

                        <mat-radio-group aria-label="Select an option" formControlName="is_admin">
                            @for(item of usersService.getUserTypes(); track item) {
                            <mat-radio-button [value]="item.value">{{ item.name }}</mat-radio-button>
                            }
                        </mat-radio-group>
                    </div>
                    <div class="p-2 w-30">

                    </div>
                </div>

                <div class="d-flex align-content-end justify-content-end">
                    <button mat-flat-button color="accent" style="width: 300px;">Zapisz</button>
                </div>
            </form>
        </div>
    </div>
    <div style="height:50px">

    </div>
</div>